import request from '@/utils/request';

// 获取当前最新的Android APK下载包
export function getApiLatestVersion() {
  return request({
    url: '/api/appver/Android/latest',
    method: 'get'
  })
}

// 获取图片验证码
export function getImageVCode() {
  return request({
    url: '/api/common/getImageVCode',
    method: 'get'
  })
}

